import layout from './layout';
import main from './main';

const rootReducer = { layout, main };

export default rootReducer;
